import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Grid } from "react-bootstrap";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import Pagination from "react-js-pagination";
import {
  fetchGalleryImages,
  updateSortGallery,
  updateLocalSort,
} from "GalleryActions";
import ImagesItem from "./images.item";
import NoContent, { NO_GALLERY } from "NoContent";
import { itemCount } from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";

class GalleryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.content_preparing_gallery,
      pageLoader: false,
      oldIndex: null,
      newIndex: null,
    };
  }

  componentDidMount() {
    this.props.actions.fetchGalleryImages(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
  }

  callContentBoard = () => {
    this.props.callContentBoardStatus();
  };

  paginationCallback = (pageNumber) => {
    this.props.actions.fetchGalleryImages(
      this.props.session,
      pageNumber,
      (callback) => {}
    );

    this.setState({ ...this.state, pageNumber });
  };

  renderImageList() {
    let pageDataLength = this.props.fetchGallery.resource.length;
    let { pageNumber } = this.state;

    var items = _.map(this.props.fetchGallery.resource, (image, index) => {
      return (
        // <div key={image.id} style={{ padding: "10px, 0px" }}>
        <ImagesItem
          key={image.id}
          image={image}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
          contentBoardStatus={this.callContentBoard}
        />
        // </div>
      );
    });
    return items;
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = _.orderBy(
      this.props.fetchGallery.resource,
      ["displayorder", "createdon"],
      ["asc", "desc"]
    );
    // console.log("oldIndex", oldIndex);
    // console.log("newIndex", newIndex);
    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
    //console.log("arrAvailable", arrAvailable);
    var newArrAvailable = [];

    this.setState({ oldIndex: oldIndex, newIndex: newIndex });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayorder: index + 1 });
    });
    this.props.actions.updateLocalSort({
      resource: newArrAvailable,
      meta: { count: this.props.fetchGallery.meta.count },
    });
    this.setState({ pageLoader: true });

    this.props.actions.updateSortGallery(
      this.props.session,
      newArrAvailable,
      (response) => {
        this.props.actions.fetchGalleryImages(
          this.props.session,
          this.state.pageNumber,
          (callback) => {
            this.setState({
              pageLoader: false,
              oldIndex: null,
              newIndex: null,
            });
          }
        );
      }
    );
  };

  render() {
    let { fetchGallery } = this.props;

    let { pageNumber, pageLoader } = this.state;
    let pageDataLength = 0;
    let imageArr = [];

    if (
      fetchGallery &&
      fetchGallery.resource &&
      fetchGallery.resource.length > 0
    ) {
      imageArr = _.orderBy(
        fetchGallery.resource,
        ["displayorder", "createdon"],
        ["asc", "desc"]
      );

      pageDataLength = fetchGallery.resource.length;
    }

    var classCustom = "";
    if (pageLoader) {
      classCustom = "gamification-page-loading";
    }

    const SortableItem = SortableElement(
      ({ value, pageDataLength, currentPage }) => (
        <ImagesItem
          key={value.id}
          image={value}
          pageDataLength={pageDataLength}
          currentPage={currentPage}
          style={{ zIndex: 10000 }}
          pagination={this.paginationCallback}
          contentBoardStatus={this.callContentBoard}
          oldIndex={this.state.oldIndex}
          newIndex={this.state.newIndex}
        />
      )
    );

    const SortableList = SortableContainer(
      ({ collection, pageDataLength, currentPage, disabled }) => {
        return (
          <div className="d-block">
            {collection.map((value, index) => {
              return (
                <SortableItem
                  key={`section-${index}`}
                  index={index}
                  value={value}
                  pageDataLength={pageDataLength}
                  currentPage={currentPage}
                  disabled={disabled}
                />
              );
            })}
          </div>
        );
      }
    );

    return (
      <div className="h-100">
        {this.state.loading ? (
          <div className="loader-container">
            <Loader />
            <div className="loader-info">{this.state.desc}</div>
          </div>
        ) : (
          <div className="h-100">
            {fetchGallery &&
            fetchGallery.resource &&
            fetchGallery.resource.length > 0 ? (
              <div>
                <div className="">
                  <SortableList
                    useDragHandle
                    axis="xy"
                    collection={imageArr}
                    onSortEnd={this.onSortEnd}
                    pageDataLength={pageDataLength}
                    currentPage={pageNumber}
                    helperClass="SortableHelper"
                  />
                </div>

                {this.props.fetchGallery.meta.count > itemCount ? (
                  <Pagination
                    activePage={this.state.pageNumber}
                    itemsCountPerPage={itemCount}
                    totalItemsCount={this.props.fetchGallery.meta.count}
                    pageRangeDisplayed={10}
                    onChange={this.paginationCallback}
                    style={{ float: "right" }}
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              <NoContent contentType={NO_GALLERY} />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state.fetchGallery :- ', state.fetchGallery);
  return {
    fetchGallery: state.fetchGallery,
    session: state.session,
  };
}

var bindActionsToProps = (dispatch) => ({
  actions: bindActionCreators(
    { fetchGalleryImages, updateSortGallery, updateLocalSort },
    dispatch
  ),
});

export default connect(mapStateToProps, bindActionsToProps)(GalleryList);
